import React, { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { LanguageProvider } from "./contexts/LanguageContext";
import { Navbar } from "./components/Navbar";
import { Footer } from "./components/Footer";
import { WhatsAppButton } from "./components/WhatsAppButton";
import { GoogleReviewButton } from "./components/GoogleReviewButton";

// Pages
import HomePage from "./pages/HomePage";
import ServicesPage from "./pages/ServicesPage";
import ServiceDetailPage from "./pages/ServiceDetailPage";
import ReferencesPage from "./pages/ReferencesPage";
import TeamPage from "./pages/TeamPage";
import ContactPage from "./pages/ContactPage";
import ImpressumPage from "./pages/ImpressumPage";
import AgbPage from "./pages/AgbPage";

// Scroll to top on route change
const ScrollToTop = () => {
  const { pathname } = useLocation();
  
  useEffect(() => {
    window.scrollTo(0, 0);
    document.title = 'BENI Gipsergeschäft GmbH | Gipser, Maler & Trockenbau in Aesch, Basel';
  }, [pathname]);
  
  return null;
};

// Scroll progress handler
const ScrollProgress = () => {
  useEffect(() => {
    const handleScroll = () => {
      const progressBar = document.querySelector('[data-testid="scroll-progress"]');
      if (progressBar) {
        const scrollTop = window.scrollY;
        const docHeight = document.documentElement.scrollHeight - window.innerHeight;
        const scrollPercent = docHeight > 0 ? scrollTop / docHeight : 0;
        progressBar.style.transform = `scaleX(${scrollPercent})`;
      }
    };
    
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  
  return null;
};

function AppContent() {
  return (
    <div className="min-h-screen flex flex-col">
      <ScrollToTop />
      <ScrollProgress />
      <Navbar />
      <div className="flex-grow">
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/dienstleistungen" element={<ServicesPage />} />
          <Route path="/dienstleistungen/:serviceId" element={<ServiceDetailPage />} />
          <Route path="/referenzen" element={<ReferencesPage />} />
          <Route path="/team" element={<TeamPage />} />
          <Route path="/kontakt" element={<ContactPage />} />
          <Route path="/impressum" element={<ImpressumPage />} />
          <Route path="/agb" element={<AgbPage />} />
        </Routes>
      </div>
      <Footer />
      <GoogleReviewButton />
      <WhatsAppButton />
    </div>
  );
}

function App() {
  return (
    <HelmetProvider>
      <LanguageProvider>
        <BrowserRouter>
          <AppContent />
        </BrowserRouter>
      </LanguageProvider>
    </HelmetProvider>
  );
}

export default App;
